export default __webpack_public_path__ + "static/media/gallery_01.ec90113b.jpg";